var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileBuilderFacilities(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "clinic",
    d: "M24,1a6.268,6.268,0,0,0-3.6,1.134L3.676,13.843A6.273,6.273,0,0,0,1,18.982V40.727A6.273,6.273,0,0,0,7.273,47h8.364a2.091,2.091,0,0,0,2.091-2.091V36.545a4.182,4.182,0,0,1,4.182-4.182h4.182a4.182,4.182,0,0,1,4.182,4.182v8.364A2.091,2.091,0,0,0,32.364,47h8.364A6.273,6.273,0,0,0,47,40.727V18.982a6.273,6.273,0,0,0-2.676-5.139L27.6,2.134A6.268,6.268,0,0,0,24,1Zm1.045,10.455A1.046,1.046,0,0,1,26.091,12.5v3.136h3.136a1.046,1.046,0,0,1,1.045,1.045v2.091a1.046,1.046,0,0,1-1.045,1.045H26.091v3.136A1.046,1.046,0,0,1,25.045,24H22.955a1.046,1.046,0,0,1-1.045-1.045V19.818H18.773a1.045,1.045,0,0,1-1.045-1.045V16.682a1.045,1.045,0,0,1,1.045-1.045h3.136V12.5a1.046,1.046,0,0,1,1.045-1.045Z",
    transform: "translate(-1 -1)",
    fill: "#387f75",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileBuilderFacilities);
export default __webpack_public_path__ + "static/media/profile-builder-facilities.3130fc55b94359a79f7a2499502de3c9.svg";
export { ForwardRef as ReactComponent };